module.exports = {"id":"208622","name":"Rubén Sobrino","rating":"72","photo":"./data/images/photos/0/208622.png","club":{"name":"Deport. Alavés","logo":"./data/images/clubs/Deport.Alaves.png"},"positions":["BU","MG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RubenSobrino0.json
// module id = 3742
// module chunks = 0